<template>
  <div>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <v-tab-item :id="'1'" style="width: 100%; height: 500px">
      <v-card>
        <v-flex xs12 sm12 md12 pa-2>
          <v-form ref="formRoom" v-model="validRoomForm" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Oda Adı"
                  v-model="
                    room.SellableProducts.SellableProduct[0].GuestRoom
                      .Description.Text.Text
                  "
                  :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <template>
                  <v-select
                    v-model="selectedAmenities"
                    :items="amenities"
                    label="Oda Özellikleri"
                    item-text="FilterName"
                    item-value="FilterId"
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.FilterName }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ selectedAmenities.length - 1 }} diğer)</span
                      >
                    </template>
                  </v-select>
                </template>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-text-field
                  label="Oda Boyut (m2)"
                  v-model="
                    room.SellableProducts.SellableProduct[0].GuestRoom.Room
                      .SizeMeasurement
                  "
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-text-field
                  label="Maksimum Kişi Adet"
                  v-model="
                    room.SellableProducts.SellableProduct[0].GuestRoom.Occupancy
                      .MaxOccupancy
                  "
                  :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-text-field
                  label="Maksimum Yetişkin"
                  v-model="
                    room.SellableProducts.SellableProduct[0].GuestRoom.Occupancy
                      .MaxAdultCapacity
                  "
                  :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md2>
                <v-btn block color="primary" @click="saveRoom()" dark
                  >Oda Ekle</v-btn
                >
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-item-group>
                  <v-container>
                    <v-layout wrap>
                      <v-flex xs4 md3>
                        <v-item>
                          <v-card
                            slot-scope="{ active, toggle }"
                            :color="active ? 'primary' : ''"
                            class="d-flex align-center"
                            dark
                            height="75"
                            width="75"
                            @click="toggle"
                          >
                            <v-scroll-y-transition>
                              <v-btn
                                v-if="photoStatus"
                                flat
                                fab
                                @click="addFiles(1)"
                              >
                                <v-icon color="info">add_a_photo</v-icon>
                              </v-btn>
                              <v-btn v-else flat fab @click="addFiles(1)">
                                <v-icon color="info">check</v-icon>
                              </v-btn>
                            </v-scroll-y-transition>
                          </v-card>
                        </v-item>
                      </v-flex>
                      <v-flex pl-1 xs4 md3>
                        <v-item>
                          <v-card
                            slot-scope="{ active, toggle }"
                            :color="active ? 'primary' : ''"
                            class="d-flex align-center"
                            dark
                            height="75"
                            width="75"
                            @click="toggle"
                          >
                            <v-scroll-y-transition>
                              <v-btn
                                v-if="photoStatustwo"
                                flat
                                fab
                                @click="addFiles(2)"
                              >
                                <v-icon color="info">add_a_photo</v-icon>
                              </v-btn>
                              <v-btn v-else flat fab @click="addFiles(2)">
                                <v-icon color="info">check</v-icon>
                              </v-btn>
                            </v-scroll-y-transition>
                          </v-card>
                        </v-item>
                      </v-flex>
                      <v-flex pl-1 xs4 md3>
                        <v-item>
                          <v-card
                            slot-scope="{ active, toggle }"
                            :color="active ? 'primary' : ''"
                            class="d-flex align-center"
                            dark
                            height="75"
                            width="75"
                            @click="toggle"
                          >
                            <v-scroll-y-transition>
                              <v-btn
                                flat
                                v-if="photoStatusthree"
                                fab
                                @click="addFiles(3)"
                              >
                                <v-icon color="info">add_a_photo</v-icon>
                              </v-btn>
                              <v-btn flat v-else fab @click="addFiles(3)">
                                <v-icon color="info">check</v-icon>
                              </v-btn>
                            </v-scroll-y-transition>
                          </v-card>
                        </v-item>
                      </v-flex>
                      <v-flex pl-1 xs4 md3>
                        <v-item>
                          <v-card
                            slot-scope="{ active, toggle }"
                            :color="active ? 'primary' : ''"
                            class="d-flex align-center"
                            dark
                            height="75"
                            width="75"
                            @click="toggle"
                          >
                            <v-scroll-y-transition>
                              <v-btn
                                flat
                                v-if="photoStatusfour"
                                fab
                                @click="addFiles(4)"
                              >
                                <v-icon color="info">add_a_photo</v-icon>
                              </v-btn>
                              <v-btn flat v-else fab @click="addFiles(4)">
                                <v-icon color="info">check</v-icon>
                              </v-btn>
                            </v-scroll-y-transition>
                          </v-card>
                        </v-item>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-item-group>

                <v-form
                  ref="formaktarim"
                  id="formaktarim"
                  method="post"
                  enctype="multipart/form-data"
                  v-model="valid"
                  lazy-validation
                >
                  <input
                    hidden
                    :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                    type="file"
                    id="file"
                    ref="file"
                    multiple
                    v-on:change="handleFileUpload(1)"
                  />
                </v-form>

                <v-form
                  ref="formaktarimtwo"
                  id="formaktarimtwo"
                  method="post"
                  enctype="multipart/form-data"
                  v-model="valid"
                  lazy-validation
                >
                  <input
                    hidden
                    :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                    type="file"
                    id="filetwo"
                    ref="filetwo"
                    multiple
                    v-on:change="handleFileUpload(2)"
                  />
                </v-form>

                <v-form
                  ref="formaktarimthree"
                  id="formaktarimthree"
                  method="post"
                  enctype="multipart/form-data"
                  v-model="valid"
                  lazy-validation
                >
                  <input
                    hidden
                    :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                    type="file"
                    id="filethree"
                    ref="filethree"
                    multiple
                    v-on:change="handleFileUpload(3)"
                  />
                </v-form>

                <v-form
                  ref="formaktarimfour"
                  id="formaktarimfour"
                  method="post"
                  enctype="multipart/form-data"
                  v-model="valid"
                  lazy-validation
                >
                  <input
                    hidden
                    :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                    type="file"
                    id="filefour"
                    ref="filefour"
                    multiple
                    v-on:change="handleFileUpload(4)"
                  />
                </v-form>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-2>
          <v-flex xs12 sm12 md12 pa-2>
            <v-data-table
              :headers="headers"
              :items="items"
              hide-actions
              class="elevation-1"
              item-key="id"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.type }}</td>
                <td class="text-xs-left">{{ props.item.size }}</td>
                <td class="text-xs-left">{{ props.item.maxOccupancyCount }}</td>
                <td class="text-xs-left">{{ props.item.maxPersonCount }}</td>
                <td class="text-xs-left">
                  <v-btn
                    flat
                    icon
                    small
                    @click="editRoom(props.item)"
                    color="primary"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>

                  <v-btn
                    flat
                    icon
                    small
                    @click="deleteRoom(props.item.roomId)"
                    color="primary"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-flex>
      </v-card>
    </v-tab-item>

    <v-layout row justify-center>
      <v-dialog v-model="dialogRoomEdit" persistent max-width="900px">
        <v-card>
          <v-card-title>
            <span class="headline">Oda Düzenle</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-form ref="formRoomUpdate" v-model="valid" lazy-validation>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        label="Oda Adı"
                        v-model="roomUpdate.Text"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <template>
                        <v-select
                          v-model="selectedUpdateAmenities"
                          :items="amenities"
                          label="Oda Özellikleri"
                          item-text="FilterName"
                          item-value="FilterId"
                          multiple
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.FilterName }}</span>
                            </v-chip>
                            <span v-if="index === 1" class="grey--text caption"
                              >(+{{ selectedAmenities.length - 1 }} diğer)</span
                            >
                          </template>
                        </v-select>
                      </template>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        label="Oda Boyut (m2)"
                        v-model="roomUpdate.SizeMeasurement"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        label="Maksimum Kişi Adet"
                        v-model="roomUpdate.MaxOccupancy"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        label="Maksimum Yetişkin"
                        v-model="roomUpdate.MaxAdultCapacity"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>

                <v-flex xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-btn
                      outline
                      color="primary"
                      @click.native="changePhotos = !changePhotos"
                      dark
                      >Fotoğrafları Düzenle</v-btn
                    >
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12 v-show="changePhotos">
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      sm6
                      md12
                      v-for="(item, index) in roomImageList"
                      :key="index"
                    >
                      <v-layout row wrap>
                        <v-flex xs8 sm6 md10>
                          <img
                            style="max-width: 100px; max-height: 100px"
                            :src="item.gorselUrl"
                          />
                        </v-flex>
                        <v-flex xs4 sm6 md2>
                          <v-btn
                            @click="deleteRoomImage(item)"
                            flat
                            icon
                            color="red"
                          >
                            <v-icon large>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click.native="dialogRoomEdit = false"
              >Vazgeç</v-btn
            >
            <v-btn color="blue darken-1" flat @click="updateRoom()"
              >Güncelle</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import auth from "@/api/auth.js";
import axios from "axios";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

export default {
  props: {
    isChoosen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      changePhotos: false,
      roomUpdate: {
        RoomId: 0,
        Text: null,
        SizeMeasurement: 0,
        MaxOccupancy: 0,
        MaxAdultCapacity: 0,
        Properties: [],
      },
      dialogRoomEdit: false,
      validRoomForm: true,
      valid: true,
      items: [],
      headers: [
        {
          text: "Oda Adı",
        },
        {
          text: "Oda Boyut (m2)",
        },
        {
          text: "Maksimum Kişi",
        },
        {
          text: "Maksimum Yetişkin",
        },
        {
          text: "İşlem",
        },
      ],
      secilenSayi: 0,
      loadingvmodel: false,
      text1: null,
      snackbar: false,
      file: [],
      photoStatus: true,
      photoStatustwo: true,
      photoStatusthree: true,
      photoStatusfour: true,
      room: {
        NextRequest: true,
        SellableProducts: {
          HotelCode: 0,
          SellableProduct: [
            {
              GuestRoom: {
                Occupancy: {
                  MaxOccupancy: 0,
                  MaxAdultCapacity: 0,
                },
                Room: {
                  RoomID: null,
                  RoomTypeCode: null,
                  SizeMeasurement: 0,
                  RoomPricingType: null,
                },
                Amenities: {
                  Amenity: [],
                },
                Description: {
                  Text: {
                    Language: null,
                    Text: null,
                  },
                  Images: {
                    Image: [`imagelist`],
                  },
                },
              },
              InvStatusType: "Active",
              ID: null,
              InvCode: null,
            },
          ],
        },
      },
      selectedAmenities: [],
      amenities: [],
      selectedUpdateAmenities: [],
      roomImageList: [],
    };
  },
  watch: {
    isChoosen: function () {
      if (this.isChoosen) {
        this.getAmenities();
        this.getRoomList();
      }
    },
  },
  methods: {
    deleteRoomImage(val) {
      this.loadingvmodel = true;
      var params = {
        Ref: val.ref,
        Url: val.gorselUrl,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/DeleteRoomImage", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            if (response.data.status == true) {
              this.roomImageList = response.body.imageItems;
              this.loadingvmodel = false;
              this.text1 = response.data.message;
              this.snackbar = true;
            } else {
              this.loadingvmodel = false;
              this.text1 = response.data.message;
              this.snackbar = true;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-DeleteRoomImage";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-DeleteRoomImage";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    editRoom(room) {
      this.selectedUpdateAmenities = [];

      this.roomUpdate.Text = room.type;
      this.roomUpdate.SizeMeasurement = room.size;
      this.roomUpdate.MaxOccupancy = room.maxOccupancyCount;
      this.roomUpdate.MaxAdultCapacity = room.maxPersonCount;
      this.roomUpdate.RoomId = room.roomId;
      this.roomImageList = room.roomImages;
      room.properties.forEach((element) => {
        this.selectedUpdateAmenities.push(element.ozellikId);
      });

      this.dialogRoomEdit = true;
    },
    updateRoom() {
      if (this.$refs.formRoomUpdate.validate()) {
        this.roomUpdate.Properties = this.selectedUpdateAmenities;
        var params = this.roomUpdate;

        this.$http
          .post(auth.HOTELRUNNER_API_URL + "api/v1/UpdateRoom", params, {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(
                  auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                ),
            },
          })
          .then(
            (response) => {
              this.text1 = response.body.message;
              this.snackbar = true;
              if (this.file.length > 0) {
                this.UploadImages(response.body.roomId);
              }else{
                this.getRoomList();
              }
              
              this.dialogRoomEdit = false;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-UpdateRoom";
                this.snackbar = true;
                this.dialogRateEdit = false;
              } else {
                this.text1 = "Service Unavailable-UpdateRoom";
                this.snackbar = true;
                this.dialogRateEdit = false;
              }
            }
          );
      }
    },
    deleteRoom(roomId) {
      var params = {
        RoomId: roomId,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/DeleteRoom", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            if (response.body.status) {
              this.getRoomList();
            } else {
              this.text1 = response.body.message;
              this.snackbar = true;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    },
    getRoomList() {
      this.loadingvmodel = true;
      var params = {
        OtelId: this.$route.query.kod,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/RoomList", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.items = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RoomList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-RoomList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    UploadImages(roomId) {
      if (this.file.length > 0) {
        this.loadingvmodel = true;
        let formData = new FormData();
        formData.append("RoomId", roomId);
        formData.append("OtelId", this.$route.query.kod);

        for (var i = 0; i < this.file.length; i++) {
          let file = this.file[i];
          formData.append("file[" + i + "]", file);
        }

        axios.defaults.baseURL = auth.HOTELRUNNER_API_URL;
        axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
        axios
          .post(auth.HOTELRUNNER_API_URL + "api/v1/UploadRoomPhoto", formData, {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(
                  auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                ),
            },
          })
          .then((response) => {
            if (response.data.status == true) {
              this.loadingvmodel = false;
              this.secilenSayi = 0;
              this.file = [];
              this.photoStatus = true;
              this.photoStatustwo = true;
              this.photoStatusthree = true;
              this.photoStatusfour = true;
              this.getRoomList(roomId);
              this.text1 = response.data.message;
              this.snackbar = true;
            } else {
              this.loadingvmodel = false;
              this.text1 = response.data.message;
              this.snackbar = true;
            }
          })
          .catch(function () {
            this.loadingvmodel = false;
            this.text1 = this.$t("Error-in-file-transfer-try-again");
            this.snackbar = true;
          });
      } else {
        this.getRoomList(roomId);
      }
    },
    handleFileUpload(val) {
      //this.file = []
      if (this.secilenSayi >= 4) {
        this.text1 = "Maksimum 4 Adet fotoğraf yükleyebilirsiniz.";
        this.snackbar = true;
      } else {
        this.cancelPhoto = true;

        var uploadedFiles;
        switch (val) {
          case 1:
            if (this.$refs.file.files.length > 1) {
              this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.');
              this.snackbar = true;
            } else {
              uploadedFiles = this.$refs.file.files;
            }
            break;
          case 2:
            if (this.$refs.filetwo.files.length > 1) {
              this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.');
              this.snackbar = true;
            } else {
              uploadedFiles = this.$refs.filetwo.files;
            }
            break;
          case 3:
            if (this.$refs.filethree.files.length > 1) {
              this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.');
              this.snackbar = true;
            } else {
              uploadedFiles = this.$refs.filethree.files;
            }
            break;
          case 4:
            if (this.$refs.filefour.files.length > 1) {
              this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.');
              this.snackbar = true;
            } else {
              uploadedFiles = this.$refs.filefour.files;
            }
            break;

          default:
            break;
        }
        var lg = uploadedFiles.length; // get length

        var items = uploadedFiles;

        if (lg > 0) {
          for (var i = 0; i < lg; i++) {
            var fileType = items[i].type; // get file type

            if (fileType === "image/png" || fileType === "image/jpeg") {
              this.secilenSayi += 1;
            } else {
              this.text1 =
                "Dosya Uzantısını kontrol ediniz. Sadece png ve jpg eklenebilir.";
              this.snackbar = true;
              this.secilenSayi = this.secilenSayi - 1;
            }
          }
        }

        if (this.secilenSayi >= 1) {
          // this.dosya1mesaj =
          //   this.secilenSayi + " " + this.$t("pcs-of-files-selected");
          switch (val) {
            case 1:
              this.photoStatus = false;
              break;
            case 2:
              this.photoStatustwo = false;
              break;
            case 3:
              this.photoStatusthree = false;
              break;
            case 4:
              this.photoStatusfour = false;
              break;

            default:
              break;
          }
        } else {
          this.dosya1mesaj = this.$t("file-has-been-chosen");
        }

        if (uploadedFiles.length > 0) {
          for (var i = 0; i < uploadedFiles.length; i++) {
            this.file.push(uploadedFiles[i]);
          }
        }
      }
    },
    addFiles(val) {
      switch (val) {
        case 1:
          this.$refs.file.click();
          break;
        case 2:
          this.$refs.filetwo.click();
          break;
        case 3:
          this.$refs.filethree.click();
          break;
        case 4:
          this.$refs.filefour.click();
          break;
        default:
          break;
      }
    },
    getAmenities() {
      var params = {
        Language: "tr",
        AllItems: true,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/RoomProperties", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.amenities = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    },
    prepareUpdateList(val) {
      var list = [];
      val.forEach((element) => {
        list.push(element);
      });

      this.roomUpdate.Properties = list;
    },
    prepareList(val) {
      var list = [];
      val.forEach((element) => {
        var item = {
          AmenityCode: element.toString(),
        };
        list.push(item);
      });

      this.room.SellableProducts.SellableProduct[0].GuestRoom.Amenities.Amenity =
        list;
    },
    saveRoom() {
      if (this.$refs.formRoom.validate()) {
        this.loadingvmodel = true;
        this.prepareList(this.selectedAmenities);
        this.room.SellableProducts.HotelCode = this.$route.query.kod;
        var params = this.room;

        this.$http
          .post(
            auth.HOTELRUNNER_API_URL + "api/hotels/ota/OTA_HotelInvNotif",
            params,
            {
              headers: {
                Authorization:
                  "Basic " +
                  window.btoa(
                    auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                  ),
              },
            }
          )
          .then(
            (response) => {
              if (response.body.Status) {
                this.UploadImages(response.body.RoomId);
              } else {
                this.loadingvmodel = false;
                this.text1 = response.body.Message;
                this.snackbar = true;
                this.progress = false;
              }
            },
            (response) => {
              if (response.status === 0) {
                this.text1 =
                  "Service Unavailable-OTA_HotelDescriptiveContentNotif";
                this.snackbar = true;
                this.progress = false;
              } else {
                this.text1 =
                  "Service Unavailable-OTA_HotelDescriptiveContentNotif";
                this.snackbar = true;
                this.progress = false;
              }
            }
          );
      }
    },
  },
  components: {
    loadingcomp,
    snackbarcomp,
  },
};
</script>
<style>
</style>